import {Accordion, Badge, Button, ButtonGroup, Card, ListGroup} from "react-bootstrap";
import React from "react";
import './Payment.css'
import {
    Call,
    CardGiftcard,
    CheckOutlined,
    FactCheck,
    HelpOutlined,
    HelpOutlineOutlined,
    Room, SaveAlt,
    Store
} from "@mui/icons-material";
import clsx from "clsx";
import {useMediaQuery} from "@material-ui/core";
import {CreditCard} from "@material-ui/icons";
import {useState} from "react";
import {wilayas} from "../../globalFunctions";
import {MultiCascader} from "rsuite";


export default function Payment(){
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    const [selectedAbonnement  , setSelectedAbonnement]=useState(null);
    const [selectedPaymentMethod , setSelectedPaymentMethod]=useState(null);
    const [selectedPaymentCenter , setSelectedPaymentCenter]=useState(null);
    /* For 'Point du vente' */
    const [selectedWilaya , setSelectedWilaya]=useState(null);
    const [selectedActivationCardMethod , setSelectedActivationCardMethod ]=useState("new");
    const [activeAccordionActiveHeaderInclude, setActiveAccordionActiveHeaderInclude] = useState(1);
    const [secondStepIsLocked , setSecondStepStatus]=useState(true);


    const AbonnementCard=({selected , name , firstLineContent , secondLineContent , badgeContent , value , setActiveAbonnementValue  })=>{
        return(
            <Button onClick={()=>{ !selected ? setActiveAbonnementValue(value) : setActiveAbonnementValue(null)}} className="d-flex flex-column abonnementCard mb-3" variant={ !selected ? "outline-primary" : "primary"}>
                <div className="mb-3"><span style={{fontSize : '1.2rem'}}> {name}</span> {badgeContent ? <Badge className="ml-2" variant="warning light">save 25%</Badge> :  <Badge style={{visibility : 'hidden'}} className="ml-2" variant="warning light">save 25%</Badge> } </div>
                <div>
                    { firstLineContent ? <div className="text-left">{firstLineContent}</div> : null }
                    { secondLineContent ? <div style={{fontSize : '0.8rem'}}>{secondLineContent}</div> : null }
                </div>
            </Button>
        )
    }

    const PaymentMethod =({ setSelectedPaymentMethodValue,selected , value , icon , methodName})=>{
        return (
            <Button className="m-lg-3 m-1 paymentCard" onClick={()=>{if(!selected){setSelectedPaymentMethodValue(value); console.log('Actual Scroll position', document.documentElement.scrollTop); setTimeout(()=>{document.documentElement.scrollTo({top: document.documentElement.scrollTop+200, behavior: 'smooth'})},100) }else{ setSelectedPaymentMethodValue(null)} }} variant={ !selected ? "outline-primary btn-rounded" : "primary btn-rounded"}>
                           <span className="btn-icon-left text-primary">
                              {icon}
                           </span>
                {methodName}
            </Button>

        )
    }

    const OfferLine=({firstColContent , secondColContent , hasHelpIcon , boldContent })=>{
        return (
            <div className="d-flex justify-content-between offersContent mt-3 mb-3">
                <div className={ clsx({"font-weight-bold" : boldContent})} >{firstColContent} {hasHelpIcon ?<HelpOutlineOutlined style={{ color : 'var(--primary)'}}/> : null } </div>
                <div className={clsx("offersContentHighlight" ,{ "font-weight-bold" : boldContent} ) }> {secondColContent}</div>
            </div>
        )
    }

    const PaymentCenter=({selected , value , info , setSelectedPaymentCenterValue})=>{
        return(
            <ListGroup.Item
                as="button"
                action
                active={selected}
                onClick={()=>!selected? setSelectedPaymentCenterValue(value) : setSelectedPaymentCenterValue(null)}
                className="flex-column align-items-start"
            >
                <div className="d-flex w-100 justify-content-between align-items-center flex-lg-row flex-column">
                    <div className="w-100 text-align-center"><Store/> {info}</div>
                    <ButtonGroup size="sm">
                        <Button variant={ selected ? "primary" : "primary tp-btn"}> <Room/> Itinéraire</Button>
                        <Button href="tel:+213794614612" variant={ selected ? "primary" : "primary tp-btn"}> <Call/> Appeler </Button>
                        <Button variant={ selected ? "primary" : "primary tp-btn"}> <SaveAlt/> RDV</Button>
                    </ButtonGroup>
                </div>
            </ListGroup.Item>
        )
    }
    return (
        <div className="d-lg-flex paymentContainer">
            {
                lg ? (
                    <div id="orderCardDesktop" className="col-4">
                        <Card>
                            <Card.Header>
                                <Card.Title>Your order</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="bordered-bottom pb-4">
                                    <div className="d-flex justify-content-between mb-2">
                                        <div>Yearly</div> <div>$89.00/ yr</div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>membership</div> <div style={{fontSize : '0.8rem'}}>Billed annually</div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between font-weight-bold pt-2 pb-2">
                                    <div>Total</div> <div>$89.00</div>
                                </div>
                                <Button disabled={(selectedAbonnement===null && secondStepIsLocked) ||  (!secondStepIsLocked && activeAccordionActiveHeaderInclude===2) } onClick={()=>{ if(secondStepIsLocked){ setSecondStepStatus(false); setActiveAccordionActiveHeaderInclude(2);}else if (activeAccordionActiveHeaderInclude===1){setActiveAccordionActiveHeaderInclude(2)} }}  className="mt-2 mb-2 w-100" variant="primary light"> {secondStepIsLocked || activeAccordionActiveHeaderInclude===1 ?  'Select and Continue' : 'Terminer'}</Button>


                                {/*<Card.Text>*/}
                                {/*    This is a wider card with supporting text and below as a*/}
                                {/*    natural lead-in to the additional content. This content*/}
                                {/*    is a little*/}
                                {/*    <br /> bit longer. Some quick example text to build the*/}
                                {/*    bulk{" "}*/}
                                {/*</Card.Text>*/}
                            </Card.Body>

                        </Card>

                    </div>
                ) : (
                    <div className="paymentMobileFooter">
                            <div className="d-flex justify-content-between pt-2 pb-2">
                                <div className="pl-5">Total</div> <div className="pr-5">$89.00</div>
                            </div>
                            <div className="d-flex flex-column offset-1 col-10">
                                <Button className="mt-2 mb-4 w-100" disabled={(selectedAbonnement===null && secondStepIsLocked) ||  (!secondStepIsLocked && activeAccordionActiveHeaderInclude===2) } onClick={()=>{ if(secondStepIsLocked){ setSecondStepStatus(false); setActiveAccordionActiveHeaderInclude(2);}else if (activeAccordionActiveHeaderInclude===1){setActiveAccordionActiveHeaderInclude(2)} }}  className="mt-2 mb-2 w-100" variant="primary light"> {secondStepIsLocked || activeAccordionActiveHeaderInclude===1 ?  'Select and Continue' : 'Terminer'}</Button>
                            </div>
                    </div>
                )
            }
            <div className=" profile card card-body p-3 offset-lg-1 col-lg-6 col-12">
                <Accordion
                    className="accordion accordion-primary-solid accordion-bordered accordion"
                    activeKey={String(activeAccordionActiveHeaderInclude)}
                >
                    <div className="accordion__item" key={1}>
                        <Accordion.Toggle
                            as={Card.Text}
                            eventKey={`${1}`}
                            className={`accordion__header ${
                                activeAccordionActiveHeaderInclude === 1
                                    ? ""
                                    : "collapsed"
                            } accordion__header--primary`}
                            onClick={() =>
                                setActiveAccordionActiveHeaderInclude(
                                    activeAccordionActiveHeaderInclude === 1
                                        ? -1
                                        : 1
                                )
                            }
                        >
                            <span className="accordion__header--icon"></span>
                            <span className="accordion__header--text">
                                        1. Membership billing
                                     </span>
                            <span className="accordion__header--indicator "></span>
                        </Accordion.Toggle>
                        <Accordion.Collapse
                            eventKey={`${1}`}
                            className="accordion__body"
                        >
                            <div className="accordion__body--text">
                                        <Card.Body>
                                            <div className="d-flex w-100 justify-content-lg-around flex-column flex-lg-row align-items-center">
                                                <AbonnementCard selected={selectedAbonnement==='Yearly'} setActiveAbonnementValue={setSelectedAbonnement} value={'Yearly'} name={'Yearly'} badgeContent={'save 25%'} firstLineContent={'$89.00/yr'} secondLineContent={'$7.42 per month'}/>
                                                <AbonnementCard selected={selectedAbonnement==='Monthly'}  setActiveAbonnementValue={setSelectedAbonnement} value={'Monthly'} name={'Monthly'}  firstLineContent={'$9.99/mo'} secondLineContent={'$119.88 per year'}/>
                                            </div>
                                            <div className="mt-3">
                                                <div className="offersTitle pb-1">Your membership includes</div>
                                                <OfferLine boldContent firstColContent={'Monthly Blank Questions'} hasHelpIcon={true} secondColContent={'50 (upgradable)'}/>
                                                <OfferLine firstColContent={'Medical library & article access'} hasHelpIcon={true} secondColContent={'Unlimited'}/>
                                                <OfferLine firstColContent={'Anki add-on'} hasHelpIcon={true} secondColContent={<CheckOutlined/>}/>
                                                <OfferLine firstColContent={'Mobile apps'} hasHelpIcon={false} secondColContent={<CheckOutlined/>}/>
                                                <OfferLine firstColContent={'Performance analytics'} hasHelpIcon={false} secondColContent={<CheckOutlined/>}/>
                                                <OfferLine firstColContent={'Personalized study recommendations'} hasHelpIcon={false} secondColContent={<CheckOutlined/>}/>
                                                <OfferLine firstColContent={'Interactive images & charts'} hasHelpIcon={false} secondColContent={<CheckOutlined/>}/>

                                            </div>


                                            {/*<Card.Text>*/}
                                            {/*    This is a wider card with supporting text and below as a*/}
                                            {/*    natural lead-in to the additional content. This content*/}
                                            {/*    is a little*/}
                                            {/*    <br /> bit longer. Some quick example text to build the*/}
                                            {/*    bulk{" "}*/}
                                            {/*</Card.Text>*/}
                                        </Card.Body>
                            </div>
                        </Accordion.Collapse>
                    </div>
                    <div className="accordion__item" key={2}>
                        <Accordion.Toggle
                            as={Card.Text}
                            eventKey={`${2}`}
                            className={`accordion__header ${
                                activeAccordionActiveHeaderInclude === 2
                                    ? ""
                                    : "collapsed"
                            } accordion__header--primary`}
                            onClick={ secondStepIsLocked ? null :  () =>
                                setActiveAccordionActiveHeaderInclude(
                                    activeAccordionActiveHeaderInclude === 2
                                        ? -1
                                        : 2
                                )
                            }
                        >
                            {secondStepIsLocked ? null :  <span className="accordion__header--icon"></span>}
                            <span className="accordion__header--text">
                                        2. Choose a payment method
                                     </span>
                            {secondStepIsLocked ? null : <span className="accordion__header--indicator "></span>}
                        </Accordion.Toggle>
                        <Accordion.Collapse
                            eventKey={`${2}`}
                            className="accordion__body"
                        >
                            <div className="accordion__body--text">
                                        <Card.Body>
                                            <div style={{ flexWrap : 'wrap'}} className="d-flex justify-content-center align-items-center">
                                                <PaymentMethod setSelectedPaymentMethodValue={setSelectedPaymentMethod} selected={selectedPaymentMethod==="CCP/Baridi Mob"} value={'CCP/Baridi Mob'} methodName={'CCP/Baridi Mob'} icon={<FactCheck className="paymentMethodIcon" />}/>
                                                <PaymentMethod setSelectedPaymentMethodValue={setSelectedPaymentMethod}  selected={selectedPaymentMethod==="Point du vente"} value={'Point du vente'} methodName={'Point du vente'} icon={<Store className="paymentMethodIcon" />}/>
                                                <PaymentMethod setSelectedPaymentMethodValue={setSelectedPaymentMethod}  selected={selectedPaymentMethod==="Code d'activation"} value={"Code d'activation"} methodName={"Code d'activation"} icon={<CardGiftcard  className="paymentMethodIcon" />}/>
                                                <PaymentMethod setSelectedPaymentMethodValue={setSelectedPaymentMethod}   selected={selectedPaymentMethod==="Carte du crédit"} value={"Carte du crédit"} methodName={"Carte du crédit"} icon={<CreditCard className="paymentMethodIcon" />} />
                                            </div>
                                            <div className="mt-3">
                                                { selectedPaymentMethod ==="CCP/Baridi Mob" ? (
                                                    <React.Fragment>
                                                        <div className="mb-lg-2 mb-4"> Veuillez déposer une photo de votre reçu pour confirmer votre abonnement</div>
                                                        <div className="input-group mb-lg-1 mb-2">
                                                            <div className="custom-file">
                                                                <input
                                                                    type="file"
                                                                    className="custom-file-input"
                                                                />
                                                                <label className="custom-file-label">
                                                                    Déposez le reçu ...
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>

                                                ): selectedPaymentMethod ==="Point du vente" ?(
                                                    <React.Fragment>
                                                        <div className="row mb-4">
                                                            <div className="col-12 mb-2"> Wilaya :</div>
                                                            <div className="col-12">
                                                                <div className="form-group">
                                                                    <select value={selectedWilaya} onChange={(e)=>setSelectedWilaya(e.target.value)} className="form-control form-control-lg">
                                                                        <option disabled selected value> -- Spécifiez votre Wilaya -- </option>
                                                                        {wilayas.map(wilaya=><option value={wilaya.id} key={wilaya.id}>{wilaya.name}</option>)}

                                                                    </select>
                                                                </div>
                                                            </div>
                                                            {
                                                                selectedWilaya!== null ? (
                                                                    <div className="basic-list-group col-12">
                                                                        <ListGroup>
                                                                            <PaymentCenter setSelectedPaymentCenterValue={setSelectedPaymentCenter} selected={selectedPaymentCenter==='Metidji Sid Ahmed , Khemis Meliana'} value={'Metidji Sid Ahmed , Khemis Meliana'} info={'Metidji Sid Ahmed , Khemis Meliana'}/>
                                                                            <PaymentCenter setSelectedPaymentCenterValue={setSelectedPaymentCenter} selected={selectedPaymentCenter==='Metidji Sid Ahmed 2 , Khemis Meliana'} value={'Metidji Sid Ahmed 2 , Khemis Meliana'} info={'Metidji Sid Ahmed 2 , Khemis Meliana'}/>
                                                                            <PaymentCenter setSelectedPaymentCenterValue={setSelectedPaymentCenter} selected={selectedPaymentCenter==='Metidji Sid Ahmed 3 , Khemis Meliana'} value={'Metidji Sid Ahmed 3 , Khemis Meliana'} info={'Metidji Sid Ahmed 3 , Khemis Meliana'}/>
                                                                        </ListGroup>
                                                                    </div>
                                                                ): null
                                                            }

                                                        </div>
                                                    </React.Fragment>
                                                    ) : selectedPaymentMethod==='Code d\'activation' ? (
                                                        <React.Fragment>
                                                            <div className="form-group mb-0 d-flex flex-lg-row flex-column justify-content-around">
                                                                <label className="radio-inline mr-3">
                                                                    <input
                                                                        type="radio"
                                                                        value="new"
                                                                        checked={selectedActivationCardMethod === "new"}
                                                                        onChange={()=>setSelectedActivationCardMethod("new")}
                                                                    /> Commander une carte
                                                                </label>
                                                                <label className="radio-inline mr-3">
                                                                    <input
                                                                        type="radio"
                                                                        value="old"
                                                                        checked={selectedActivationCardMethod === "old"}
                                                                        onChange={()=>setSelectedActivationCardMethod("old")}
                                                                    /> J'ai déja un code d'activation
                                                                </label>
                                                            </div>
                                                            {
                                                                selectedActivationCardMethod==="new" ? (
                                                                    <div>
                                                                        <div className="row mb-4 mt-2">
                                                                            <div className="col-12 mb-3">Spécifiez Votre Adresse :</div>
                                                                            <div className="col-12">
                                                                                <div className="form-group">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-lg"
                                                                                        placeholder="L'adresse ...."
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-12 mb-3">Spécifiez Votre Numéro de téléphone :</div>
                                                                            <div className="col-12">
                                                                                <div className="form-group">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-lg"
                                                                                        placeholder="L'adresse ...."
                                                                                        value={'0794614612'}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        <div className="row mb-4 mt-2">
                                                                            <div className="col-12 mb-3">Entrer votre code d'activation :</div>
                                                                            <div className="col-12">
                                                                                <div className="form-group">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-lg"
                                                                                        placeholder="Le code ..."
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }

                                                        </React.Fragment>

                                                    ): null


                                                }

                                            </div>



                                            {/*<Card.Text>*/}
                                            {/*    This is a wider card with supporting text and below as a*/}
                                            {/*    natural lead-in to the additional content. This content*/}
                                            {/*    is a little*/}
                                            {/*    <br /> bit longer. Some quick example text to build the*/}
                                            {/*    bulk{" "}*/}
                                            {/*</Card.Text>*/}
                                        </Card.Body>
                            </div>
                        </Accordion.Collapse>
                    </div>

                </Accordion>
            </div>





        </div>
    )
}
